"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const overviewInputs = [
  {
    name: "variant",
    type: "string",
    enum: ["earnPoints", "clubOverview"],
    required: true,
    defaultValue: "clubOverview",
  },
  {
    name: "title",
    friendlyName: "Title",
    type: "string",
    required: true,
    showIf: `options.get("variant") === "earnPoints"`,
    defaultValue: "Overview title",
  },
  {
    name: "subtitle",
    friendlyName: "Overview subtitle",
    type: "string",
    required: true,
    showIf: `options.get("variant") === "earnPoints"`,
    defaultValue: "Descriptive content lorem ipsum dolor sit amet.",
  },
  {
    name: "secondarySubtitle",
    friendlyName: "Overview description",
    type: "longText",
    required: true,
    showIf: `options.get("variant") === "earnPoints"`,
    defaultValue:
      "Descriptive content lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et",
  },
  {
    name: "items",
    friendlyName: "Tiles",
    type: "list",
    required: true,
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
      {
        name: "imageUrl",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
    ],
    defaultValue: [
      {
        title: "Tile 1",
        description: "Description 1",
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
      {
        title: "Tile 2",
        description: "Description 2",
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
      {
        title: "Tile 3",
        description: "Description 3",
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("items");
      if (Array.isArray(items) && items.length > 4) {
        options.set("items", items.slice(0, 4));
        alert("You can add maximum 4 tiles");
      }
    },
  },
] as const satisfies Inputs;

export const OverviewComponent: RegisteredComponent = {
  name: "Overview",
  component: dynamic(async () => withValidation(overviewInputs, (await import("./Overview")).Overview, "Overview")),
  inputs: overviewInputs,
};
